/**
 * Эндпоинты для работы с аутентификацией
 */
export const AUTH_ENDPOINTS = {
  /** POST /v1/auth/signup - Регистрация нового пользователя */
  signup: '/v1/auth/signup',
  
  /** POST /v1/auth/signin - Вход в систему */
  signin: '/v1/auth/signin',
  
  /** POST /v1/auth/signout - Выход из системы */
  signout: '/v1/auth/signout',
  
  /** POST /v1/auth/refresh - Обновление токена */
  refresh: '/v1/auth/refresh',
} as const
